import { Component } from "@angular/core";
import { BaseListComponent } from "projects/sepidz-web-framework-shell/src/lib/shared/controls/base/base-list.component";
import { InvDailyRemainFormComponent } from "../inv-daily-remain-form/inv-daily-remain-form.component";
import { UntypedFormGroup, UntypedFormControl } from "@angular/forms";
import { Branch } from "projects/sepidz-web-framework/src/lib/models";
import { GridFilter } from "projects/sepidz-web-framework/src/lib/services";
import { take } from "rxjs/operators";

@Component({
  selector: "ngx-inv-daily-remain-list",
  templateUrl: "./inv-daily-remain-list.component.html",
  styleUrls: ["./inv-daily-remain-list.component.scss"],
})
export class InvDailyRemainListComponent extends BaseListComponent {
  isAdd: boolean = true;
  isEdit: boolean = true;
  isDelete: boolean = true;
  formGroup = new UntypedFormGroup({
    branchFilter: new UntypedFormControl(),
  });

  allBranchesExceptCallCenter: Branch[] = [];

  onFilter: GridFilter[] = [
    {
      Filed: "CreatedDate",
      Value: 0,
      Skip: 0,
      Take: 15,
      Operator: "desc",
      Type: "S",
    },
  ];

  constructor() {
    super();
    this.inputEditorform = InvDailyRemainFormComponent;
  }

  ngOnInit(): void {
    this.apiName = "InvDailyRemain";
    this.areaName = "RestaurantSale";
    this.label = this.translate("ClientApp.FrontOffice.Inv.DailyRemain.Leftover");
    this.httpCommonService
      .getList("Branch/GetAllBranch")
      .pipe(take(1))
      .subscribe(async (data: Branch[]) => {
        this.allBranchesExceptCallCenter = data.filter((x) => !x.AccessToAllBranches);
      });
    if (this.isMultiBranch) {
      this.onBranchFilterClear();
    }
  }

  public onBranchFilterChanged(branches: Branch[]): void {
    if (branches.length) this.filterBranchWithOrOperator(branches);
    else this.onBranchFilterClear();
  }

  public onBranchFilterClear(): void {
    this.onFilter = [
      {
        Filed: "BranchId",
        Value: 0,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      },
    ];
  }

  private filterBranchWithOrOperator(branches: Branch[]): void {
    this.onFilter = Object.assign([], []);
    branches.forEach((branch) => {
      const branchFilter: GridFilter = {
        Filed: "BranchId",
        Value: branch.Id,
        Skip: 0,
        Take: 0,
        Operator: "eq",
        Type: "F",
      };

      if (branches.length > 1) {
        branchFilter.Logic = "or";
      }
      this.onFilter.push(...[branchFilter]);
    });
  }
}
